import React from "react";
import { Check } from "lucide-react";
import { MEDIA_CHANNELS } from "../../lib/sr";

// Reusable media-channel multi-select used when creating / regenerating a growth plan.
export default function ChannelPicker({ value, onChange, testid = "channel-picker" }) {
  const selected = value || [];
  const toggle = (key) => {
    const next = selected.includes(key) ? selected.filter((k) => k !== key) : [...selected, key];
    onChange(next);
  };
  return (
    <div data-testid={testid}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 8 }}>
        {MEDIA_CHANNELS.map((c) => {
          const on = selected.includes(c.key);
          return (
            <button
              key={c.key}
              type="button"
              onClick={() => toggle(c.key)}
              data-testid={`${testid}-${c.key}`}
              aria-pressed={on}
              style={{
                display: "flex", alignItems: "center", gap: 8, textAlign: "left", cursor: "pointer",
                border: on ? "1.5px solid var(--blue)" : "1.5px solid var(--border)",
                background: on ? "var(--blue-light)" : "#fff", borderRadius: 10, padding: "9px 12px",
                fontSize: 13, fontWeight: 600, color: "var(--navy)",
              }}
            >
              <span style={{
                width: 18, height: 18, borderRadius: 5, flexShrink: 0, display: "inline-flex",
                alignItems: "center", justifyContent: "center",
                background: on ? "var(--blue)" : "transparent", border: on ? "none" : "1.5px solid var(--border)",
              }}>{on && <Check size={13} color="#fff" />}</span>
              {c.label}
            </button>
          );
        })}
      </div>
      <div className="sr-muted" style={{ fontSize: 11, marginTop: 8 }}>Pick the channels you want in this plan — you can fine-tune the split next in the Media Mix planner.</div>
    </div>
  );
}
